import React from "react";

import styles from "./styles.module.scss";

type Props = {
  children: any;
  align?: "center" | "right" | "left";
  weight?: "normal" | "bold";
};

const PageTitle = ({ children, align = "left", weight = "bold" }: Props) => {
  return (
    <div className={styles.pageTitle}>
      <h1
        style={{
          textAlign: align,
          fontWeight: weight,
        }}
      >
        {children}
      </h1>
    </div>
  );
};

export default PageTitle;
